import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "../../css/Manage.css";
import "../../css/space/ManageSpaceReview.css";
import SpaceApi from "../../api/spaceApi";
import SpaceReviewApi from "../../api/spaceReviewApi";
import moment from "moment";
import { toast } from "react-toastify";
import MeetingProgramReviewApi from "../../api/meetingProgramReviewApi";
import AlertPopup from "../../components/AlertPopup";

const ManageMeetingProgramReview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const [item, setItem] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [alertValue, setAlertValue] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  // useEffect(() => {
  //   console.log('asdasd');

  //   if (location.state) {
  //     const { id } = location.state;
  //     setReviewId(location.state.id);
  //     getSpaceReview(id);
  //   }
  // }, [location]);

  // const getSpaceReview = async (id) => {

  //   try {
  //     const info = (await MeetingProgramReviewApi.GetDetail(id)).data.content;
  //     console.log(info);

  //     let date = moment(info?.createdAt).local().format("YYYY/MM/DD");
  //     setReviewScore(info?.score.toFixed(1));
  //     setReviewInfo(info);
  //     setCreatDate(date);

  //     //별점 채우기
  //     let star = [];
  //     for (let i = 0; i < info?.score; i++) {
  //       star.push("/img/star-full.svg");
  //     }
  //     for (let i = 0; i < 5 - info?.score; i++) {
  //       star.push("/img/star-empty.svg");
  //     }
  //     setReviewStar(star);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    MeetingProgramReviewApi.GetDetail(Number(id))
      .then((res) => setItem(res.data.data.content))
      .catch(() => toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요."));
  }, []);

  useEffect(() => {
    const del = async () => {
      try {
        if (deleteId <= 0) {
          return;
        }

        await MeetingProgramReviewApi.Del(deleteId);
        navigate(-1);
        toast("삭제되었습니다.");
      } catch (error) {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    };
    if (alertValue) {
      del();
    }
  }, [alertValue]);

  const programHandler = async () => {
    setIsOpen(true);
    setDeleteId(id);
  };

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-space-review">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
          <div>
            <Link onClick={programHandler}>삭제</Link>
          </div>
        </div>
        <div className="Manage-form manage-form-gathering-review-see-more">
          <span>리뷰</span>
          <div className="Manage-form-view-details space-review-detail">
            <span>이메일</span>
            <span>{item?.member ? item.member.email : null}</span>
          </div>
          <div className="Manage-form-view-details space-review-detail">
            <span>별명</span>
            <span>{item?.member ? item.member.nickname : null}</span>
          </div>
          <div className="Manage-form-view-details space-review-detail">
            <span>작성일자</span>
            <span>{moment(item?.createdAt).local().format("YYYY/MM/DD")}</span>
          </div>
          <div className="gathering-review-detail-img-container">
            {item?.programReviewFiles &&
              item.programReviewFiles.map((item, index) => {
                return <img key={index} src={item.imageUrl} />;
              })}
          </div>
          <div className="gathering-review-contents-container">
            <div className="gathering-review-scope-container">
              {[...Array(item?.score ?? 0)].map((_, index) => {
                return <img key={index} src={"/img/star-full.svg"} />;
              })}
              {[...Array(5 - (item?.score ?? 0))].map((_, index) => {
                return <img key={index} src={"/img/star-empty.svg"} />;
              })}
              <span>리뷰{item?.score.toFixed(1)}</span>
            </div>
            <span style={{ whiteSpace: "pre-wrap" }}>{item?.content}</span>
          </div>
        </div>
        <AlertPopup
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          headerTitle={"프로그램 리뷰 삭제"}
          content={"삭제된 데이터는 복구가 불가능합니다."}
          setAlertValue={setAlertValue}
          cancelTitle={"취소"}
          confirmTitle={"삭제"}
        />
      </section>
    </div>
  );
};

export default ManageMeetingProgramReview;
